import { Link, Page, Text, View } from "@react-pdf/renderer";
import ContractStyles from "../../../assets/styles/contractStyles";

const TableOfContents = ({ sections = [], pageOffset = 0 }) => {
  const styles = ContractStyles();

  return (
    <Page size="A4" style={[styles.page, styles.py_lg, styles.px_xxl]}>
      <View style={[styles.flexColumn, styles.gap_sm]}>
        <Text style={[styles.contentSemibold, styles.text_primary]}>
          Contents
        </Text>

        <View style={[styles.flexColumn, styles.gap_xs]}>
          {sections.map(({ id, number, title, page }, index) => (
            <Link key={id} src={`#${id}`} style={{ textDecoration: "none" }}>
              <View style={[styles.flexRow, styles.alignEnd]} wrap={false}>
                <Text
                  style={[
                    styles.contentSmall,
                    styles.text_primary,
                    { width: 34 },
                  ]}
                >
                  {number ? `${number}.` : ""}
                </Text>

                <Text
                  style={[
                    styles.contentSmall,
                    styles.text_primary,
                    { maxWidth: 330 },
                  ]}
                >
                  {title}
                </Text>

                <View
                  style={[
                    styles.grow,
                    {
                      marginHorizontal: 4,
                      marginBottom: 3,
                      borderBottomWidth: 1,
                      borderBottomStyle: "dotted",
                      borderBottomColor: "#081e56",
                    },
                  ]}
                />

                <Text
                  style={[
                    styles.contentSmall,
                    styles.text_primary,
                    styles.textRight,
                    { width: 22 },
                  ]}
                >
                  {page ?? pageOffset + index + 1}
                </Text>
              </View>
            </Link>
          ))}
        </View>
      </View>

      {/* <PageFooter /> */}
    </Page>
  );
};

export default TableOfContents;
